import { Mapper } from "planning-portal-library/src/lib/core/base";
import { TimeZonesEntity } from "./master-plan-time-zones-entity";
import { TimeZones } from "planning-portal-library/src/lib/core/domain/models/time-zones";



export class MasterPlanTimeZonesRepositoryMapper extends Mapper<
  TimeZonesEntity,
  TimeZones
> {
  constructor() {
    super();
  }

  mapFrom(param: TimeZonesEntity): TimeZones {
    return {
      displayName: param.displayName,
      id: param.id
    };
  }

  mapTo(param: TimeZones): TimeZonesEntity {
    return {
        displayName: param.displayName,
        id: param.id
      };
  }
}